import {
  PRODUCTION_ENABLED_LANGUAGES,
  PRODUCTION_WEB_HOSTS,
  STAGING_ENABLED_LANGUAGES,
} from '../constants/languageAvailability.constants'
import type { Language } from '../translations'

export type EnvLike = Record<string, string | undefined>

export function isProductionWebHost(hostname: string): boolean {
  const normalized = hostname.trim().toLowerCase()
  return PRODUCTION_WEB_HOSTS.some((host) => normalized === host)
}

/**
 * True when the app should expose only production-reviewed locales.
 * Web production builds on zporti.com are locked; preview/staging hosts stay open.
 * Native production builds (no hostname) are locked.
 */
export function isI18nProductionLocked(
  env: EnvLike = process.env as EnvLike,
  hostname?: string | null,
): boolean {
  const expoPublicEnv = (env.EXPO_PUBLIC_ENV || '').trim().toLowerCase()
  if (expoPublicEnv !== 'production') {
    return false
  }

  if (hostname != null && hostname.trim() !== '') {
    return isProductionWebHost(hostname)
  }

  return true
}

export function getEnabledLanguages(
  env: EnvLike = process.env as EnvLike,
  hostname?: string | null,
): Language[] {
  const enabled = isI18nProductionLocked(env, hostname)
    ? PRODUCTION_ENABLED_LANGUAGES
    : STAGING_ENABLED_LANGUAGES

  return [...enabled]
}

export function isLanguageEnabled(
  language: Language,
  env: EnvLike = process.env as EnvLike,
  hostname?: string | null,
): boolean {
  return getEnabledLanguages(env, hostname).includes(language)
}

export function coerceToEnabledLanguage(
  language: Language,
  env: EnvLike = process.env as EnvLike,
  hostname?: string | null,
): Language {
  return isLanguageEnabled(language, env, hostname) ? language : 'en'
}
